import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=f1c448d8&scoped=true&"
import script from "./FormStep.vue?vue&type=script&lang=ts&"
export * from "./FormStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c448d8",
  null
  
)

export default component.exports